import { BaseButtons, BaseScatoleNavigazione, findRouteWithKey, useRichiestaServer, useRoutes, useUser } from "@lucan/base-ui";
import { OPERAZIONI } from "configuration/ConfigurazioneApi";
import { CHIAVI_ROUTES } from "configuration/ConfigurazioneRotte";

export default function Staff({tabs= false}) {
  const { routesVisibiliNeiMenu_VisibiliDalloUser } = useUser();
  const { homeConComando, homeSenzaComando, componenteLogin } = useRoutes()
  const parentRoute =  findRouteWithKey(routesVisibiliNeiMenu_VisibiliDalloUser, CHIAVI_ROUTES.STAFF)
  const { isUserLoggato, isUserLoggatoConComando } = useUser()
  const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServer()


  if (!isUserLoggato()) return componenteLogin
  
  return (<>{!tabs && <BaseScatoleNavigazione
    routes={parentRoute.subRoutes}
  />}
    <BaseButtons.Custom
        testo={"Cancella cache"}
        onClick={() =>  inviaOperazione(OPERAZIONI.CLEAR_CACHE)}
        sx={{ mt: 2 }}
      />
  </>
  )
}
